export default __webpack_public_path__ + "db9fc0c68bd60a2a3480f09c5a82d3f6.png";